import React, { type HTMLAttributes } from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';

import { Paragraph } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Button, Hero, WysiwygField } from '../../../../components';
import type { NodeHomePage as Type } from '../../../../types/uncinc_profile/nodes';

import './style.scss';

interface HomePageProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const NodeHomePageNLdoet: React.FC<HomePageProps> = ({
  entity,
  className,
}) => {
  const classes = classNames(className, 'NodeHomePageNLdoet');
  const homePage = entity.toJS();
  const title = homePage.title[0].value;
  const body = homePage.body[0]?.processed;
  const primaryLink = homePage.field_link[0];
  const secondaryLink = homePage.field_link_secondary[0];
  const paragraphs = homePage.field_paragraphs;
  const media = homePage.field_media_item[0];
  const { bundle } = media;
  let image = null;
  let video = null;
  if (bundle === 'image') {
    image = media;
  } else if (bundle === 'video_file') {
    video = media;
  }

  return (
    <article typeof="schema:WebPage" className={classes}>
      <Hero image={image} video={video}>
        <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <h1 className="Hero__wrapper__title">{title}</h1>
          {body && (
            <WysiwygField
              property="schema:text"
              className="Hero__wrapper__body"
              html={body}
            />
          )}
          <div className="Hero__wrapper__links">
            {primaryLink && (
              <Button withIcon buttonIcon primary href={primaryLink.uri} className="Hero__wrapper__links__primaryButton">
                {primaryLink.title}
              </Button>
            )}
            {secondaryLink && (
              <Button withIcon buttonIcon primary href={secondaryLink.uri} className="Hero__wrapper__links__secondaryButton">
                {secondaryLink.title}
              </Button>
            )}
          </div>
        </div>
      </Hero>
      <div className="Paragraphs NodeHomePageNLdoet__paragraphs">
        {paragraphs.length > 0 && paragraphs.map((paragraph) => {
          const targetId = paragraph.target_id;

          return (
            <Paragraph
              key={`paragraph:${targetId}`}
              id={targetId}
              entity={Immutable.fromJS(paragraph.entity)}
            />
          );
        })}
      </div>
    </article>
  );
};

export default NodeHomePageNLdoet;
